// JsFromRoutes CacheKey 489b7f8eed8142c98d55f315b82e8410
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from 'utils/js_from_routes_client'

export default {
  new: /* #__PURE__ */ definePathHelper('get', '/employer_onboarding/banking'),
  publicToken: /* #__PURE__ */ definePathHelper('post', '/employer_onboarding/banking/public_token'),
  bankingError: /* #__PURE__ */ definePathHelper('post', '/employer_onboarding/banking/error'),
}
